import React, { Component } from 'react'
import PropTypes from 'prop-types'
import dateformat from 'dateformat'
import DayPicker from 'react-day-picker'
import Popover from '../ui/Popover'

export default class DatePicker extends Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string
  }

  handlePickerChange = (day) => {
    this.props.onChange(dateformat(day, 'mm/dd/yyyy'))
    this.refs.popover.setState({showing: false})
  }

  handleInputChange = e => {
    const {value} = e.target
    this.props.onChange(value)
  }

  handleFocus = e => {
    this.refs.popover.setState({showing: true, target: e.target})
  }

  render () {
    const {value} = this.props
    const date = Date.parse(value)
    const initialMonth = date ? new Date(date) : new Date()

    return <div>
      <input type='text' value={value} placeholder='MM/DD/YYYY'
        className='form-control'
        onClick={this.handleFocus}
        onChange={this.handleInputChange}
      />
      <Popover ref='popover' placement='bottom center'>
        <DayPicker
          enableOutsideDays
          numberOfMonths={1}
          initialMonth={initialMonth}
          onDayClick={this.handlePickerChange}
          modifiers={{
            selected: day => {
              return dateformat(day, 'mm/dd/yyyy') === value
            }
          }}
        />
      </Popover>
    </div>
  }
}



// WEBPACK FOOTER //
// ./app/components/fields/DatePicker.js